import { useEffect, useState } from 'react';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged, createUserWithEmailAndPassword } from 'firebase/auth';
import Api from '../api';
const Authentication = (firebase) => {
  const [authUser, setAuthUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(firebase.auth, (user) => {
      if(user.uid === 'mIx721WKurVotrfVmggEOqKYCfl1' || user.uid === 'mxG5BZs7hUd1qsas4wKH6Lh0fZg1')
        setAuthUser(user);
      else
        setAuthUser(null);
    });
  }, []);
  const authenticate = (email, password) => {
    return signInWithEmailAndPassword(firebase.auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if(user.uid === 'mIx721WKurVotrfVmggEOqKYCfl1' || user.uid === 'mxG5BZs7hUd1qsas4wKH6Lh0fZg1') {
          setAuthUser(user);
          return [user, false];
        } else {
          signOut();
          setAuthUser(null);
          return [0, true];
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        setAuthUser(null);
        return [errorCode, true];
      });
  };
  const createUser = (email, password) => {
    return createUserWithEmailAndPassword(firebase.auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        return [user, false];
      })
      .catch((error) => {
        const errorCode = error.code;
        return [errorCode, true];
      });
  };
  const logout = () => {
    return signOut(firebase.auth)
      .then(() => {
        setAuthUser(null);
        localStorage.removeItem('token');
        return [null, false];
      })
      .catch((error) => {
        return [error.message, true];
      });
  };
  return { authenticate, authUser, logout, createUser };
};

export default Authentication;
